import { Checkbox } from 'antd';
import type { InternalScenarioRecord } from '../types';

type ScenarioNameCellProps = {
    record: InternalScenarioRecord;
    showAnalyticsCheckbox: boolean;
    onClick?: (record: InternalScenarioRecord) => void;
};

const ScenarioNameCell = ({ record, showAnalyticsCheckbox, onClick }: ScenarioNameCellProps) => {
    const showCheckbox =
        showAnalyticsCheckbox &&
        (typeof record.analytics_enabled === 'boolean' ? record.analytics_enabled : true);

    return (
        <div className="flex items-center gap-3">
            {showCheckbox ? <Checkbox /> : null}
            <button
                type="button"
                className="text-fontColor underline bg-transparent border-0 p-0 cursor-pointer text-[14px] leading-[20px]"
                onClick={(event) => {
                    event.stopPropagation();
                    onClick?.(record);
                }}
            >
                {record.scenario_name}
            </button>
        </div>
    );
};

export default ScenarioNameCell;
